import { useState, React } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from 'sushiweb/Button';
import { TableClickButton, TableClickButtonOverflow } from './styles';
import { DRAFTED } from './constants';
import CreateProgramModal from './CreateProgramModal';
import { programStatusEnum } from '../common/components/constants';
import { GC_PLAN } from './CreateProgramModal/ProgramForms/common/Components/constants';
import ZTrackingClient from '../../jumbo/ZTrackingClient';
import { PROGRAM_DETAILS_ROUTE } from '../../constants/routes';

const PlanDetailsBtns = ({ plan, title, toStep, btnSize, isFullFlexEnabled }) => {
  const status = programStatusEnum[(plan?.program_status)];
  const [showModal, setShowModal] = useState(false);
  const [canModalClose, setCanModalClose] = useState(true);
  const navigate = useNavigate();

  const modalClose = {
    enable: () => setCanModalClose(true),
    disable: () => setCanModalClose(false),
  };

  const closeModal = override => {
    if (canModalClose || override) {
      setShowModal(false);
    }
  };

  const handleClick = () => {
    if (isFullFlexEnabled) {
      navigate(PROGRAM_DETAILS_ROUTE.replace(':programId', plan?.program_id));
      return;
    }

    setShowModal(true);
    if (title === GC_PLAN && toStep === 3) {
      ZTrackingClient.recordClick({
        ui_source: btnSize === 'medium' ? 'GIFTING_DETAILS' : 'GIFTING',
        component: 'PAY_NOW_BUTTON',
        meta_data: { program_id: plan?.program_id },
      });
    }
  };

  return (
    <>
      <CreateProgramModal
        title={title}
        showModal={showModal}
        closeModal={closeModal}
        modalClose={modalClose}
        planData={plan}
        planDataFlag={status !== DRAFTED}
        toStep={toStep}
      />
      <TableClickButtonOverflow>
        {title === GC_PLAN ? (
          <Button size={btnSize} onClick={handleClick}>
            Pay
          </Button>
        ) : (
          <Button
            size='small'
            appearance='link'
            style={{ margin: '0', padding: '0' }}
            onClick={handleClick}
          >
            <TableClickButton>{plan.name}</TableClickButton>
          </Button>
        )}
      </TableClickButtonOverflow>
    </>
  );
};

PlanDetailsBtns.propTypes = {
  plan: PropTypes.objectOf(PropTypes.any),
  title: PropTypes.string.isRequired,
  toStep: PropTypes.number,
  btnSize: PropTypes.string,
  isFullFlexEnabled: PropTypes.bool,
};

PlanDetailsBtns.defaultProps = {
  plan: {},
  toStep: 1,
  btnSize: 'small',
  isFullFlexEnabled: false,
};

export default PlanDetailsBtns;
